import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import footerLogo from "../../assets/images/jcaoc-logo@2x.png";
import styles from "./layout.module.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import homeService from "../../services/home-service";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const handleDownloadUserGuide = () => {
    homeService
      .getDownloadUserGuideAPI()
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      })
      .catch((error) => {
        console.error("Error", error);
      });
  };
  const baseUrl = process.env.REACT_APP_API_URL;
  return (
    <div className={styles.footerSection}>
      <Box
        sx={{
          width: "100%",
          position: "relative",
          bottom: 0,
          bgcolor: "#404040",
          color: "white",
          textAlign: "center",
          paddingY: { md: 3, sm: 2, xs: 3 },
        }}
      >
        <Box className={styles.max_width_container}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                src={footerLogo}
                alt="Logo"
                style={{ height: "40px", marginRight: "10px" }}
              />
            </Box>
            <Typography
              className={styles.footerLinks}
              variant="body2"
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 2,
                textAlign: "center",
              }}
            >
              <a
                href="https://csc.georgiacourts.gov/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.commanLink}
                style={{ textDecoration: "none", borderBottom: "none" }}
              >
                {t("About")}
              </a>

              <Link
                to="/#"
                className={styles.footerLink}
                onClick={() => handleDownloadUserGuide()}
                style={{ display: "none" }}
              >
                {t("User Guide")}
              </Link>
<a
                href={`${baseUrl}/media/userguide2.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.footerLink}
                style={{ textDecoration: "none", borderBottom: "none" }}
              >
                {t("User Guide")}
              </a>
              {/* <Link to="/faq" className={styles.footerLink}>
                {t("FAQ")}
              </Link> */}
              <Link to="/contact" className={styles.footerLink}>
                {t("Contact")}
              </Link>
              <a
                href={`${baseUrl}/media/childsupportstatute2.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.footerLink}
                style={{ textDecoration: "none", borderBottom: "none" }}
              >
                {t("Child Support Statute")}
              </a>
              <Link to="/basicChildSupport" className={styles.footerLink}>
                {t("Basic Child Support Obligation Table")}
              </Link>
            </Typography>
          </Box>

          <Box
            className={styles.border_bottom}
            sx={{
              width: { lg: "80%", md: "80%", sm: "80%", xs: "90%" },
              margin: "auto",
              mt: 2,
            }}
          ></Box>
          <Typography
            variant="body2"
            fontSize={11}
            sx={{ mt: 2, color: "#F2F2F2" }}
          >
            {t("© Georgia Child Support Commission")}{" "}
            {new Date().getFullYear()}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default Footer;